<template>
  <div>
    <el-dialog
      title="Asignación de tiempos"
      :visible.sync="DialgoVisible"
      @open="openingDialog"
      @close="closingDialog"
      width="70%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="AllTasksAsigned"
      :destroy-on-close="true"
    >
      <el-alert
        v-if="!AllTasksAsigned"
        title="No podrá salir de esta ventana hasta que todas las tareas tengan tiempo asignado!"
        type="warning"
        center
        show-icon
        description="Recuerde darle al Boton guardar para que se graben los cambios realizados!"
        class="flex justify-center"
        :closable="false"
      >
      </el-alert>
      <el-alert
        v-if="AllTasksAsigned"
        title="Todo Listo!"
        type="success"
        center
        show-icon
        description="Ya puede guardar y salir!."
        class="flex justify-center"
        :closable="false"
      >
      </el-alert>
      <!-- <el-row>
        <el-col :span="3">
          <EmployeeSelector
            placeholder="Responsable"
            @selection-change="OnResponsibleSelected"
          />
        </el-col>
      </el-row> -->
      <rabbey-table-3
        :stripe="true"
        :loading="loadingTime"
        :data="DataToDisplay"
        :columns="TimeColumns"
        :actions="TimeActions"
        @rtable-push-action="handlePushAction"
        :maxheight="600"
        :row-class-name="tableRowClassName"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="closingDialog"
          :loading="loadingTime"
          :disabled="loadingTime || !AllTasksAsigned"
          >Cancelar</el-button
        >
        <el-button
          type="primary"
          @click="SavingTaskTimeAsigned"
          :loading="loadingTime"
          :disabled="loadingTime || !AllTasksAsigned"
          >Guardar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TimeAssigmentColumns, {
  TimeAsignmentActions
} from "@/columns/TimeAssigmentColumns";
//import EmployeeSelector from "@/components/Company/EmployeeSelector";
export default {
  name: "TimeAssigment",
  components: {
    //EmployeeSelector
  },
  props: {
    isItVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    actualResquest: {
      type: Array,
      default: () => [],
      required: false
    },
    whatsFor: {
      type: String,
      default: "",
      required: false
    },
    filtersForData: {
      type: Object,
      default: () => {},
      required: false
    },
    ActualWeekNumber: {
      type: Number,
      default: 0,
      required: false
    }
  },
  data() {
    return {
      // Define your component's data properties here
      TimeData: [],
      TimeColumns: TimeAssigmentColumns(this),
      TimeActions: TimeAsignmentActions,
      TasksWithTimeAsigned: [],
      loadingTime: false
    };
  },
  computed: {
    // Define your computed properties here
    DataToDisplay() {
      if (this.whatsFor === "edit_task_time") {
        return this.actualResquest;
      } else {
        return this.TimeData;
      }
    },

    DialgoVisible() {
      return this.isItVisible;
    },
    AllTasksAsigned() {
      let areTheyAsigned = false;

      if (this.loadingTime === true) {
        return false; // If loading, cannot be considered as assigned
      } else if (this.DataToDisplay.length === 0) {
        return true; // If there are no tasks, consider them as assigned
      }

      this.DataToDisplay.every((task) =>
        this.TasksWithTimeAsigned.some(
          (ta) => ta.ID === task.ID && ta.TimeOntask > 0
        )
      )
        ? (areTheyAsigned = true)
        : (areTheyAsigned = false);

      return areTheyAsigned;
    }
  },

  methods: {
    // Define your methods here
    async GetDataToAsign() {
      this.loadingTime = true;
      let actualYear = new Date().getFullYear();
      let actualMonth = new Date().getMonth() + 1;
      await this.$http
        .get("/api/ReporteGestion/GetAllTaskForReport", {
          params: {
            CompanySelected: "TB",
            GerenciaID: this.filtersForData.Direction,
            ResponsableID: this.filtersForData.Responsible,
            WeekOnMothSelected: this.ActualWeekNumber,
            Year: actualYear,
            Month: actualMonth,
            closed: false,
            IsFromAddTimeReport: true
          }
        })
        .then((response) => {
          this.TimeData = response.data;
          this.loadingTime = false;
        });
    },
    async openingDialog() {
      this.TasksWithTimeAsigned = [];
      if (this.whatsFor !== "edit_task_time") {
        await this.GetDataToAsign();
      }
    },
    closingDialog() {
      this.$emit("DialogCloses", false);
    },
    updatingWeekNumberValue(val) {
      val;
    },
    updatingDayOfWeekValue(val) {
      val;
    },
    updatingTimeOntaskValue(dataToAdd) {
      if (
        this.TasksWithTimeAsigned.length > 0 &&
        this.TasksWithTimeAsigned.some((ta) => ta.ID === dataToAdd.ID)
      ) {
        // if(this.TasksWithTimeAsigned.some(ta => ta.ID === dataToAdd.OriginalID)) {
        this.TasksWithTimeAsigned.map((task) => {
          if (task.ID === dataToAdd.ID) {
            return {
              ...task,
              NoTask: dataToAdd.ID,
              Description: dataToAdd.Name,
              TimeOntask: dataToAdd.TimeOntask,
              TypeOfTime: "h" // Default to "h" if not provided
            };
          }
        });
      }
      // }
      else {
        dataToAdd.NoTask = dataToAdd.ID;
        dataToAdd.Description = dataToAdd.Name;
        this.TasksWithTimeAsigned.push(dataToAdd);
      }
    },
    updatingTypeOfTimeValue(dataToAdd) {
      if (
        this.TasksWithTimeAsigned.length > 0 &&
        this.TasksWithTimeAsigned.some((ta) => ta.ID === dataToAdd.ID)
      ) {
        // if(this.TasksWithTimeAsigned.some(ta => ta.ID === dataToAdd.OriginalID)) {
        this.TasksWithTimeAsigned.map((task) => {
          if (task.ID === dataToAdd.ID) {
            return {
              ...task,
              NoTask: dataToAdd.ID,
              Description: dataToAdd.Name,
              TypeOfTime: "h" // dataToAdd.TypeOfTime
            };
          }
        });
      }
      // }
      else {
        dataToAdd.NoTask = dataToAdd.ID;
        dataToAdd.Description = dataToAdd.Name;
        this.TasksWithTimeAsigned.push(dataToAdd);
      }
    },
    updatingWeekValue(dataToAdd) {
      let actualYear = new Date().getFullYear();
      let actualMonth = new Date().getMonth() + 1;

      const params = {
        ID: dataToAdd.OriginalID,
        DirectiontID: dataToAdd.DirectionID,
        ResponsableID: dataToAdd.ResponsableID,
        NoTask: dataToAdd.ID,
        OriginalID: dataToAdd.OriginalID,
        Description: dataToAdd.Name,
        TimeOntask: dataToAdd.TimeOntask,
        TypeOfTime: "h", // dataToAdd.TypeOfTime,
        Year: actualYear,
        Month: actualMonth,
        CompanySelected: "TB"
      };
      // {
      //   ID: dataToAdd.OriginalID,
      //   DirectionID: dataToAdd.DirectionID,
      //   ResponsableID: dataToAdd.ResponsableID,
      //   NoTask: dataToAdd.ID,
      //   OriginalID: dataToAdd.OriginalID,
      //   Description: dataToAdd.Name,
      //   TimeOntask: dataToAdd.TimeOntask,
      //   TypeOfTime: dataToAdd.TypeOfTime,
      //   WeekNumber: dataToAdd.WeekNumber,
      //   CompanySelected: "TB"
      // };

      this.$http
        .post("/api/ReporteGestion/AgregarNuevaTarea", params)
        .then(async () => {
          this.$message({
            message: "Tareas Agregada exitosamente a la semana",
            type: "success"
          });
          //await this.GetDataToAsign();
          this.$emit("TaskAdded");

          //this.actualResquest = response.data;
        });
    },
    OnResponsibleSelected() {
      //this.$emit("EmployeedSelected", employSelected);
    },
    SavingTaskTimeAsigned() {
      this.loadingTime = true;
      const params = {
        Items: this.TasksWithTimeAsigned
      };
      if (
        this.whatsFor === "edit_task_time" /*&&
        this.TasksWithTimeAsigned[0].TaskOnReportId !== null*/
      ) {
        this.$http
          .put("/api/ReporteGestion/UpdateTaskTime", params)
          .then(async () => {
            this.$message({
              message: "Tareas Actualizadas exitosamente",
              type: "success"
            });
            //await this.GetDataToAsign();
            this.$emit("TaskAdded");
            this.loadingTime = false;
            //this.actualResquest = response.data;
          })
          .catch((err) => {
            console.error(err);
            this.loadingTime = false;
          });
      } else if (this.whatsFor === "Asigning_Time") {
        this.$http
          .put("/api/ReporteGestion/UpdateTaskTime", params)
          .then(async () => {
            this.$message({
              message: "Tareas Agregadas exitosamente",
              type: "success"
            });
            //await this.GetDataToAsign();
            this.$emit("TaskAdded");
            this.loadingTime = false;
            //this.actualResquest = response.data;
          })
          .catch((err) => {
            console.error(err);
            this.loadingTime = false;
          });
      }
    },
    tableRowClassName({ row }) {
      if (row.TimeOntask === 0) {
        return "warning-row";
      } else if (row.TimeOntask > 0) {
        return "success-row";
      }
      return "";
    },
    async handlePushAction(option) {
      const { row } = option;
      row;
      switch (option.command) {
        case "view_task":
          // console.log("View Task", row);
          // this.DetailsDialogData = {
          //   requestsId: row.OriginalID,
          //   comments: [],
          //   descripcionLaga: row.Descripcion,
          //   descripcionCorta: row.Name,
          //   commentReasonToReopen: "",
          //   Reopen: "",
          //   evidences: []
          // };
          // this.isDetailsVisible = true;
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    // This lifecycle hook is called when the component is mounted
    // You can perform any setup or initialization here
  },
  watch: {
    // DataToDisplay(val) {
    //   // Watch for changes in DataToDisplay and
    // },
  }
};
</script>

<style scoped lang="scss">
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
